export const getRedirectPath = (authenticated, userData) => {
  // Debug info
  // console.log("getRedirectPath - userData:", userData);
  // console.log("getRedirectPath - authenticated:", authenticated);
  
  if (!authenticated) return "/auth/login";
  if (!userData || !userData.role) return "/auth/login";

  // Special case: If user is authenticated but has no educational level,
  // redirect to the educational level selection page
  if (userData.role === "user" && needsEducationalLevel(userData)) {
    return "/auth/register/educational-level";
  }

  // If user needs to select a subscription plan, redirect to billing page
  if (userData.role === "user" && needsSubscription(userData)) {
    return "/auth/register/billing";
  }

  return userData.role === "admin" ? "/dashboard" : "/app/home";
};

// Check if a user needs to complete registration with educational level
export const needsEducationalLevel = (userData) => {
  if (!userData) return false;

  const needsLevel = userData &&
    userData.role === "user" &&
    (userData.educational_level === null || !userData.educational_level);

  // console.log("needsEducationalLevel check for:", userData);
  // console.log("Result:", needsLevel);

  return needsLevel;
};

// Check if a user needs to select a subscription plan
export const needsSubscription = (userData) => {
  if (!userData) return false;

  // console.log("needsSubscription check - userData:", userData);
  // console.log("needsSubscription check - subscription:", userData.subscription);

  // More explicit check for subscription status
  // Check if subscription is active AND not expired
  const hasActiveSubscription =
    userData.subscription &&
    userData.subscription.status === 'active';

  // Check if subscription is expired
  const hasExpiredSubscription =
    userData.subscription &&
    userData.subscription.status === 'expired';

  // Check if subscription is canceled
  const hasCanceledSubscription =
    userData.subscription &&
    userData.subscription.status === 'canceled';

  // User needs subscription if:
  // 1. No subscription exists, OR
  // 2. Subscription is expired, OR
  // 3. Subscription is canceled
  const needs = userData.role === "user" && (!hasActiveSubscription || hasExpiredSubscription || hasCanceledSubscription);

  return needs;
};